import { Component, toNative, Vue } from '@natureos/vue-facing-decorator';

@Component({ name: 'Container' })
class Container extends Vue {}

export default toNative(Container);
export { default as Container } from './container.component.vue';
